import { render, staticRenderFns } from "./lkuInstallment.vue?vue&type=template&id=4a39076a&"
import script from "./lkuInstallment.vue?vue&type=script&lang=js&"
export * from "./lkuInstallment.vue?vue&type=script&lang=js&"
import style0 from "./lkuInstallment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports